import { pascalCase } from 'Tracking/utils';
import { useEffect } from 'react';
import { useBookingNavbarContext } from './BookingNavbarContext';

const defaultBookingNavbar = {
  continueAction: null,
  hideContinueButton: false,
  isPriceLoading: false,
  navbarRef: null,
  priceShouldIncludeDonation: true,
  noEdit: true,
  overwriteContinueButton: false,
  portalPosition: undefined,
  isDisabled: false,
  validationCallback: null,
  shouldDisplay: true,
  paymentLabel: undefined,
};

export const useBookingNavbar = (props) => {
  const context = useBookingNavbarContext();

  const useSetter = ({ name }) => {
    const value = props?.[name];
    const setter = context['set' + pascalCase(name)];
    useEffect(() => {
      if (value !== undefined && setter) {
        setter(() => value);
        return () => {
          setter(defaultBookingNavbar[name]);
        };
      }
    }, [value]);
  };
  useSetter({ name: 'validationCallback' });
  useSetter({ name: 'processValidation' });
  useSetter({ name: 'priceShouldIncludeDonation' });
  useSetter({ name: 'paymentLabel' });
  useSetter({ name: 'isDisabled' });
  useSetter({ name: 'continueBtn' });
  useSetter({ name: 'isPriceLoading' });
  useSetter({ name: 'hideContinueButton' });
  useSetter({ name: 'noEdit' });
  useSetter({ name: 'overwriteContinueButton' });
  useSetter({ name: 'portalPosition' });
  useSetter({ name: 'continueAction' });
  useSetter({ name: 'shouldDisplay' });
};
